import { render, staticRenderFns } from "./TimeZoneAndLanguageSelectorRow.vue?vue&type=template&id=5d3fcf9e&scoped=true&"
import script from "./TimeZoneAndLanguageSelectorRow.vue?vue&type=script&lang=js&"
export * from "./TimeZoneAndLanguageSelectorRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3fcf9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1751410358/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3fcf9e')) {
      api.createRecord('5d3fcf9e', component.options)
    } else {
      api.reload('5d3fcf9e', component.options)
    }
    module.hot.accept("./TimeZoneAndLanguageSelectorRow.vue?vue&type=template&id=5d3fcf9e&scoped=true&", function () {
      api.rerender('5d3fcf9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Core/TimeZoneAndLanguageSelectorRow.vue"
export default component.exports